import { HighlightBlockQuote as HighlightBlockQuote$1 } from '@cbhq/cdx-components';
import { getEntryProps } from '../utils/getEntryProps.js';
import { CONTENTFUL_COMPONENTS_STYLE_MAP } from './contentToPropsMap.js';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_QUOTE_CONTENT_MODEL_ID = 'cdxHighlightBlockQuote';
function HighlightBlockQuote({
  style,
  quote,
  attribution,
  hasSpacingTop,
  isFullWidth = true
}) {
  const styleValue = CONTENTFUL_COMPONENTS_STYLE_MAP[style];
  const _getEntryProps = getEntryProps(attribution, {}),
    authorName = _getEntryProps.authorName,
    authorTitle = _getEntryProps.authorTitle,
    authorImage = _getEntryProps.authorImage;
  return /*#__PURE__*/jsx(HighlightBlockQuote$1, {
    quote: quote,
    authorPhotoUrl: authorImage?.fields.file.url,
    authorName: authorName || '',
    authorTitle: authorTitle,
    style: styleValue,
    hasSpacingTop: hasSpacingTop,
    isFullWidth: isFullWidth
  });
}
export { HIGHLIGHT_QUOTE_CONTENT_MODEL_ID, HighlightBlockQuote };
//# sourceMappingURL=HighlightBlockQuote.js.map
